import Spinner from '../components/Spinner'
import { useAppConfig } from '../modules/appConfig'
import { useSavedMoveId } from '../modules/moves'
import { getPlatformFromHostname, removePlatformFromUrl } from '../modules/platforms'
import Maintenance from './Maintenance'

type AppGateProps = {
  children?: React.ReactNode
}

const AppGate: React.FC<AppGateProps> = ({ children }) => {
  const { data: appConfig, loading } = useAppConfig()
  const hasPlatform = !!getPlatformFromHostname()
  const savedMoveId = useSavedMoveId()
  const pathname = window?.location?.pathname
  const moveIdInUrl = pathname.match(/\/move\/([^/]+)/i)?.[1]
  const hasMove = !!savedMoveId || !!moveIdInUrl
  const hasInvalidPlatform = appConfig && hasPlatform && !appConfig?.platform
  const shouldRemovePlatform = hasInvalidPlatform && !hasMove

  if (shouldRemovePlatform) {
    document.location = removePlatformFromUrl()
  }

  if (loading || !appConfig || shouldRemovePlatform) {
    return (
      <div className="child:child:!text-[#fa372c]">
        <Spinner floating />
      </div>
    )
  }

  if (!appConfig?.enabled) {
    return <Maintenance />
  }

  return children
}

export default AppGate
